import React, { useContext } from "react";
import { Box,  Typography } from "@mui/material";
import BodyPart from "./BodyPart";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import ExerciseCard from "./ExerciseCard";
import { ArrowBack, ArrowForward} from "@mui/icons-material";
import { Update } from "../App";

const LeftArrow = () => {
  const { mode} = useContext(Update);
  const { scrollPrev } = useContext(VisibilityContext);
  return (
    <Typography onClick={() => scrollPrev()} className="right-arrow1" color={mode==="light"?("red" ): ('blue')}>
      <ArrowBack/>
    </Typography>
  );
};
const RightArrow = () => {
  const { mode} = useContext(Update);

  const { scrollNext } = useContext(VisibilityContext);
  return (
    <Typography onClick={() => scrollNext()} className="left-arrow1" color={mode==="light"?("red" ): ('blue')}>
      <ArrowForward/>
    </Typography>
  );
};
const HorizontalScrolbar = ({ data, bodyPart, setBodyPart, isBodyParts }) => {
  return (
    <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
      {data.map((item) => (
        <Box
          key={item.id || item}
          itemId={item.id || item}
          title={item.id || item}
          m="0 40px"
        >
          {isBodyParts ? (
            <BodyPart
              item={item}
              bodyPart={bodyPart}
              setBodyPart={setBodyPart}
            />
          ) : (
            <ExerciseCard exercise={item} />
          )}
        </Box>
      ))}
    </ScrollMenu>
  );
};

export default HorizontalScrolbar;
